import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './reducer/store'
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import clevertap from 'clevertap-web-sdk';
import {CTACCOUNTID} from '../src/services/common/endpoints'
import TagManager from 'react-gtm-module';
import {GTMACCOUNTID} from "../src/services/common/endpoints";
import { consoleLog } from './services/common/utils';

let persistor = persistStore(store);
try{
clevertap.init(CTACCOUNTID);

try{
// Handle user opt-in
function handleOptIn() {
  clevertap.optOut(false); // User opted in
  // Additional logic if needed
}

// Handle user opt-out
function handleOptOut() {
  clevertap.optOut(true); // User opted out
  // Additional logic if needed
}

 // Register the service worker for push notifications
 if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('Service worker registered:', registration);
      })
      .catch((error) => {
        console.error('Service worker registration failed:', error);
      });
  });
}
}catch(e){
  consoleLog("error in service worker registration CT:"+e+"")
}

}catch(e){}

try{
  const tagManagerArgs = {
    gtmId: GTMACCOUNTID
  }
  TagManager.initialize(tagManagerArgs)
}catch(e){}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
